import { render, staticRenderFns } from "./BackendOrderGenerationOverview.vue?vue&type=template&id=2d2baa0a&lang=pug"
import script from "./BackendOrderGenerationOverview.vue?vue&type=script&lang=js"
export * from "./BackendOrderGenerationOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports